import { NAV_PATH, TOS_GRP_ID } from '@/router/constants';
import { SelectItem } from '@/pages/policy/interface';

/**
 *  ==================================== 이용 약관 ====================================
 */
export const termsTab = {
	cate: '',
	title: '이용약관',
	subTab: [
		{ title: '서비스 이용약관', name: '서비스이용약관', value: TOS_GRP_ID.TERMS.TERMS, ord: 1 },
		{ title: '홈페이지 이용약관', name: '홈페이지이용약관', value: TOS_GRP_ID.TERMS.TERMS_HOME, ord: 2 }
	]
};

export const termsSelectItem: SelectItem[] = [];

export const terms2SelectItem: SelectItem[] = [];

export const privacyTab = {
	cate: '',
	title: '개인정보 처리방침',
	subTab: [
		{ title: '개인정보 처리방침', name: '개인(신용)정보수집및이용동의', value: TOS_GRP_ID.PRIVACY.PRIVACY, ord: 1 },
		{ title: '이메일 무단수집거부', name: '이메일무단수집거부', value: TOS_GRP_ID.PRIVACY.PRIVACY_EMAIL, ord: 2 }
	]
};
export const privacySelectItem: SelectItem[] = [];
